import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import {
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faCalendarAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUpload,
  faBookmark,
  faBook,
  faPen,
  faPowerOff,
  faShoppingCart,
  faCreditCard,
  faLock,
  faClock,
  faRedoAlt,
  faListUl,
  faAngleDoubleRight,
  faUnlock,
  faArrowCircleRight,
  faPlay
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faCheck,
  faCheckCircle,
  faInfoCircle,
  faCalendarAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faArrowUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faEye,
  faEyeSlash,
  faCaretDown,
  faCaretUp,
  faUpload,
  faBookmark,
  faBook,
  faPen,
  faPowerOff,
  faShoppingCart,
  faCreditCard,
  faLock,
  faClock,
  faRedoAlt,
  faListUl,
  faAngleDoubleRight,
  faUnlock,
  faArrowCircleRight,
  faPlay
);

Vue.component("vue-fontawesome", FontAwesomeIcon);

import "./config/axios";

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas"
});

import vueVimeoPlayer from "vue-vimeo-player";

Vue.use(vueVimeoPlayer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
